module.exports = __webpack_public_path__ + "static/img/5.c5aa459a.png";